<div>Term name: {{ termName }}</div>
<div>Term value: {{ getTermValue() }}</div>
